import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { CdnIcon, CdnIconNames } from '@shared/ui';

export interface IconTitleProps {
	content: string | React.ReactElement;
	mainIcon: React.ReactElement | CdnIconNames;
	contentRight?: React.ReactElement;
	className?: string;
}

const IconTitle: React.FC<IconTitleProps> = ({ content, mainIcon, contentRight, className }) => {
	const { IconTitle: theme } = useTheme('Shared');

	return (
		<div className={cn(theme.root, className)}>
			<div className={theme.iconWrapper}>
				{typeof mainIcon === 'string' ? <CdnIcon icon={mainIcon} className={theme.cdnIcon} /> : mainIcon}
			</div>
			<div className={theme.content}>
				{typeof content === 'string' ? <span className={theme.title}>{content}</span> : content}
			</div>
			{contentRight && <div className={theme.contentRight}>{contentRight}</div>}
		</div>
	);
};

export default IconTitle;
